/**
 * ログイン後の遷移先として受け付ける同一オリジン内のパス。ブラウザと同じ URL パーサで解決し、
 * `//host`・`/\\host`・制御文字入りの `/\t/host` など別オリジンに解決される値は "/" に落とす。
 */
export function safeNextPath(next: string | null, origin: string): string {
	if (next === null || !next.startsWith("/")) return "/";
	const url = new URL(next, origin);
	return url.origin === origin ? url.pathname + url.search + url.hash : "/";
}

export function loginPathWithNext(next: string): string {
	return `/login?next=${encodeURIComponent(next)}`;
}
